import { connect } from "react-redux";
import { uploadCsv } from "../actions/CsvUploaderActions";
import CsvUploader from "../components/CsvUploader";

// no props needed for CsvUploader
const mapStateToProps = null;

const mapDispatchToProps = {
  uploadCsv,
};

export default connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps
)(CsvUploader);



// WEBPACK FOOTER //
// ./src/scripts/containers/CsvUploaderContainer.ts